import { safeDefine } from "../../registration/safe-define.js";
import { SliderBufferElement } from "../../ui/slider/buffer.js";
//#region src/define/ui/slider-buffer.ts
safeDefine(SliderBufferElement);
//#endregion
